import { Button }     from './button.class'
import { SPIN_STATE } from '../../constants/spinState/spin-state.constant'

/**
 * @file Defines the {@link SpinButton} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Class for handling desktop spin button
  * @extends Button
  */
 export class SpinButton extends Button {

    /**
     * States of spin button and maps buttons to styles based on state
     * @memberof SpinButton
     * @protected
     * @instance
     * @type {object}
     */
    _states

    /**
     * Initialise core button properties
     * @param {string[]} assets_  - Array of data URIs containing button assets.
     * @param {string}   id_      - ID of button.
     * @param {string[]} states_  - Array of possible button states.
     * @param {boolean}  visible_ - Whether button is initially visible.
     * @param {boolean}  text_    - Whether button has text.
     * @param {function} click_   - Object containg click events for each state.
     */
    constructor(assets_, id_, states_, visible_, text_ = false, click_ = null) {

        super(assets_, id_, states_, visible_, text_, click_) //Call parent constructor

        //Initialise states
        this._states = {

            //Spin state
            spin: {

                //Spin button styles
                spinButton: {
                    'pointer-events': 'none'
                },

                //Stop button styles
                stopButton: {
                    'pointer-events': 'all'
                }

            },

            //Stop state
            stop: {

                //Spin button styles
                spinButton: {
                    'pointer-events': 'all'
                },

                //Stop button styles
                stopButton: {
                    'pointer-events': 'none'
                }

            }

        }

        //If desktop
        if (!framework.isTouch()) {

            //On spin
            SPIN_STATE.onSpin.add(v_ => {

                //If spinning
                if (v_) {

                    //Style button and set state
                    this.style('start')
                    this.state = 'STOP'

                }

                //Not spinning
                else {

                    //Style button and set state
                    this.style('stop')
                    this.state = 'SPIN'

                }

            })

        }

    }

    /**
     * Styles button based on state
     * @param {string} s_ - State of spin button.
     */
    style(s_) {

        //Loop through button id's
        for (let id in this._states[s_]) {
                        
            let b = document.getElementById(id) //Store reference to button
            
            //Loop through styles
            for (let p in this._states.stop[id]) {
                b.setAttribute('style', `${p}:${this._states.stop[id][p]}`) //Apply style
            }

        }

    }

 }